import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics, handleMenuLinkScroll } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexExperientialHeader.scss';

const AmexExperientialHeader = (
  {
    baseRequestUrl,
    headerConfig: {
      links,
      image,
    },
    Analytics,
    hideNewEvents,
    hidePastEvents,
    hideEvents,
    hideNAA,
    hideEditorials,
    isNonUSLocation,
    locationSlug,
    matchMedia,
    scrollTo,
  }
) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const externalLinkUrl = `${baseRequestUrl}Experiential/bannerImages/${image}`;

  const linksConfigWithHideSections = links
    .filter((link) => {
      if (link.name === 'experiences') {
        if (!hideEvents) return link;
      } else if (link.name === 'newevents') {
        if (!hideNewEvents) return link;
      } else if (link.name === 'pastevents') {
        if (!hidePastEvents) return link;
      } else if (link.name === 'acquisition') {
        if (!hideNAA && !isNonUSLocation) return link;
      } else if (link.name === 'editorials') {
        if (!hideEditorials) return link;
      } else if (link.name === 'restaurantEvents') {
        if (link?.label) return link;
      } else return link;
      return false;
    });

  const handleAnalyticsClick = (label) => {
    const extraParam = {
      action_name: 'Menu - Click',
      item_name: label,
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
  };

  const onScroll = () => {
    if (window.scrollY <= 70) {
      setIsScrolled(false);
    } else {
      setIsScrolled(true);
    }
  };

  useEffect(() => {
    if (matchMedia.md) {
      window.addEventListener('scroll', onScroll);
    }
    return () => window.removeEventListener('scroll', onScroll);
  }, [matchMedia]);

  const displayCTA = (cta, index) => {
    const { label, url, name } = cta;

    switch (name) {
      case 'experiences':
      case 'newevents':
      case 'pastevents':
      case 'acquisition':
      case 'editorials':
        return (
          <Link
            href={window?.location?.href?.split('#')[0] + url}
            className="AmexExperientialHeader__link"
            onContextMenu={() => handleAnalyticsClick(label)}
            onClick={() => {
              handleAnalyticsClick(label);
              scrollTo(url);
              handleMenuLinkScroll(index, 'pageMenu', 800);
            }}
          >
            {label}
          </Link>
        );
      case 'restaurantEvents':
        return (
          <Link
            href={url.replace('{locationCode}', locationSlug)}
            target="_blank"
            className="AmexExperientialHeader__link"
            onContextMenu={() => handleAnalyticsClick(label)}
            onClick={() => {
              handleAnalyticsClick(label);
              handleMenuLinkScroll(index, 'pageMenu', 800);
            }}
          >
            {label}
            <img
              src={externalLinkUrl}
              alt="link opens in a new window"
              className="AmexExperientialHeader__external-icon"
            />
          </Link>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={cx('AmexExperientialHeader', {
        scrolled: isScrolled,
      })}
    >
      <nav
        aria-label="Page navigation"
        className="AmexExperientialHeader__nav"
      >
        <div className="container">
          <div className="AmexExperientialHeader__wrapper">
            <div className="AmexExperientialHeader__menu">
              <ul id="pageMenu">
                {linksConfigWithHideSections.map((link, index) => (
                  <li
                    key={link.label}
                    className="AmexExperientialHeader__item"
                  >
                    {displayCTA(link, index)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

AmexExperientialHeader.propTypes = {
  headerConfig: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({})),
    image: PropTypes.string,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  hideEvents: PropTypes.bool.isRequired,
  hideEditorials: PropTypes.bool.isRequired,
  hideNAA: PropTypes.bool.isRequired,
  isNonUSLocation: PropTypes.bool.isRequired,
  hideNewEvents: PropTypes.bool,
  hidePastEvents: PropTypes.bool,
  locationSlug: PropTypes.string,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  scrollTo: PropTypes.func.isRequired,
};

AmexExperientialHeader.defaultProps = {
  locationSlug: 'new-york-ny',
  hideNewEvents: true,
  hidePastEvents: true,
};

export default AmexExperientialHeader;
